import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold pdb-20 fs-xl" }, "Administrator - Authentication/PIN Request", -1)
const _hoisted_2 = { class: "d-flex flex-column gap-20 w-100" }
const _hoisted_3 = { class: "d-flex gap-20 w-100 flex-column flex-md-row" }
const _hoisted_4 = {
  key: 0,
  class: "btn-delete"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-plus text-white" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Address Information", -1)
const _hoisted_9 = { class: "d-flex gap-20 w-100 flex-column flex-md-row" }
const _hoisted_10 = { class: "d-flex gap-20 w-100 flex-column flex-md-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fw-semibold" }, "Personal Information", -1)
const _hoisted_12 = { class: "d-flex gap-20 w-100 flex-column flex-md-row" }
const _hoisted_13 = { class: "d-flex gap-20 w-100 flex-column flex-md-row" }
const _hoisted_14 = { class: "w-100 d-flex mt-40 gap-20 justify-content-center flex-column" }
const _hoisted_15 = { class: "d-flex gap-20 flex-md-row flex-column" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  width: "24",
  height: "16",
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#8EC986",
  d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_ReCaptcha = _resolveComponent("ReCaptcha")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TextInput, {
          type: "text",
          name: "mixed",
          label: "Company Name ",
          placeholder: "Company Name",
          max: 60,
          modelValue: _ctx.employerAuth.CompanyName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employerAuth.CompanyName) = $event)),
          "is-required": true,
          error: _ctx.errors.CompanyName
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_TextInput, {
          type: "text",
          name: "mixed",
          label: "EIN/ TAXID ",
          placeholder: "EIN/ TAXID",
          max: 60,
          modelValue: _ctx.employerAuth.TaxID,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.employerAuth.TaxID) = $event)),
          "is-required": true,
          error: _ctx.errors.TaxID
        }, null, 8, ["modelValue", "error"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employerAuth.DBANames, (dba, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "d-flex align-items-end gap-4"
        }, [
          _createVNode(_component_TextInput, {
            type: "text",
            name: "mixed",
            label: "DBA Name ",
            placeholder: "DBA Name",
            max: 60,
            modelValue: dba.name,
            "onUpdate:modelValue": ($event: any) => ((dba.name) = $event),
            error: _ctx.errors.DBAName
          }, null, 8, ["modelValue", "onUpdate:modelValue", "error"]),
          (dba.showDelete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("i", {
                  class: "iatse-icon-trash icon_delete plan-modal fs-4",
                  onClick: ($event: any) => (_ctx.deleteDBA(index))
                }, null, 8, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-primary pdl-15 pdr-15",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addDBA && _ctx.addDBA(...args)))
              }, _hoisted_7))
        ]))
      }), 128)),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_TextInput, {
          type: "text",
          name: "mixed",
          label: "Street 1",
          placeholder: "Street 1",
          max: 30,
          modelValue: _ctx.employerAuth.Address.Street1,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.employerAuth.Address.Street1) = $event)),
          "is-required": true,
          error: _ctx.errors['Address.Street1']
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_TextInput, {
          type: "text",
          name: "mixed",
          label: "Street 2 ",
          placeholder: "Street 2",
          max: 30,
          modelValue: _ctx.employerAuth.Address.Street2,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.employerAuth.Address.Street2) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_TextInput, {
          type: "text",
          name: "mixed",
          label: "City",
          placeholder: "City",
          max: 50,
          modelValue: _ctx.employerAuth.Address.City,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.employerAuth.Address.City) = $event)),
          "is-required": true,
          error: _ctx.errors['Address.City']
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_TextInput, {
          type: "text",
          name: "number",
          label: "Zip/Postal Code ",
          placeholder: "Zip/Postal Code",
          max: 9,
          modelValue: _ctx.employerAuth.Address.Zip,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.employerAuth.Address.Zip) = $event)),
          "is-required": true,
          error: _ctx.errors['Address.Zip']
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_SelectComponent, {
          label: "State",
          selectedOption: _ctx.employerAuth.Address.State,
          "onUpdate:selectedOption": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.employerAuth.Address.State) = $event)),
          options: _ctx.states,
          "is-required": true,
          error: _ctx.errors['Address.State']
        }, null, 8, ["selectedOption", "options", "error"])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_TextInput, {
          type: "text",
          label: "First Name",
          placeholder: "First Name",
          max: 12,
          modelValue: _ctx.employerAuth.FirstName,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.employerAuth.FirstName) = $event)),
          "is-required": true,
          error: _ctx.errors?.FirstName
        }, null, 8, ["modelValue", "error"]),
        _createVNode(_component_TextInput, {
          type: "text",
          label: "Middle Name",
          placeholder: "Middle Name",
          max: 12,
          modelValue: _ctx.employerAuth.MiddleName,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.employerAuth.MiddleName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TextInput, {
          type: "text",
          label: "Last Name",
          placeholder: "Last Name",
          max: 25,
          modelValue: _ctx.employerAuth.LastName,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.employerAuth.LastName) = $event)),
          "is-required": true,
          error: _ctx.errors?.LastName
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_TextInput, {
          type: "text",
          name: "mixed",
          label: "Title",
          placeholder: "Title",
          max: 200,
          modelValue: _ctx.employerAuth.Title,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.employerAuth.Title) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TextInput, {
          type: "text",
          name: "phone",
          label: "Phone",
          placeholder: "Enter Phone",
          max: 16,
          modelValue: _ctx.employerAuth.Phone,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.employerAuth.Phone) = $event)),
          "is-required": true,
          error: _ctx.errors?.Phone
        }, null, 8, ["modelValue", "error"])
      ]),
      _createVNode(_component_TextInput, {
        type: "email",
        label: "Email",
        placeholder: "Email",
        max: 100,
        modelValue: _ctx.employerAuth.Email,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.employerAuth.Email) = $event)),
        "is-required": true,
        error: _ctx.errors?.Email
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_ReCaptcha, {
        recaptchaError: _ctx.recaptchaError,
        loadingRecaptcha: _ctx.loadingRecaptcha,
        token: _ctx.token,
        "onUpdate:recaptchaError": _cache[14] || (_cache[14] = ($event: any) => (_ctx.recaptchaError = $event)),
        "onUpdate:loadingRecaptcha": _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadingRecaptcha = $event)),
        "onUpdate:token": _cache[16] || (_cache[16] = ($event: any) => (_ctx.token = $event))
      }, null, 8, ["recaptchaError", "loadingRecaptcha", "token"]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary w-100 lh-1 border-radius-8",
          onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)), ["prevent"])),
          disabled: _ctx.loadingSubmit
        }, " Discard ", 8, _hoisted_16),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary plan-modal w-100 lh-1 border-radius-8",
          onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["prevent"])),
          onKeypress: _cache[19] || (_cache[19] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["prevent"]), ["enter"])),
          disabled: _ctx.loadingSubmit
        }, [
          _createTextVNode(" Submit "),
          (_ctx.loadingSubmit)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_20))
            : _createCommentVNode("", true)
        ], 40, _hoisted_17)
      ])
    ])
  ], 64))
}